export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';
export const CREATE_CONTENT_SUCCESS = 'CREATE_CONTENT_SUCCESS';
export const LOAD_INTENT_SUCCESS = 'LOAD_INTENT_SUCCESSS';
export const LOAD_DOMAIN_SUCCESS = 'LOAD_DOMAIN_SUCCESS';
export const CREATE_INTENT_SUCCESS = 'CREATE_INTENT_SUCCESS';
export const UPDATE_INTENT_SUCCESS = 'UPDATE_INTENT_SUCCESS';
export const LOAD_INTENT_UTTERENCE_SUCCESS = 'LOAD_INTENT_UTTERENCE_SUCCESS';
export const LOAD_RULE_CONTENT_SUCCESS = 'LOAD_RULE_CONTENT_SUCCESS';
export const CREATE_PUBLISH_SUCCESS = 'CREATE_PUBLISH_SUCCESS';
export const LOAD_DASHBOARD_SUCCESS = 'LOAD_DASHBOARD_SUCCESS';
export const LOAD_FORM_SUCCESS = 'LOAD_FORM_SUCCESS';
export const LOAD_CONTENT_SUCCESS = 'LOAD_CONTENT_SUCCESS';
export const CLEAN_DATA_SUCCESS = 'CLEAN_DATA_SUCCESS';
export const SAVE_APPROVAL_CONTENT_SUCCESS = 'SAVE_APPROVAL_CONTENT_SUCCESS';
export const TRAIN_CONTENT_SUCCESS = 'TRAIN_CONTENT_SUCCESS';
export const LOAD_TEST_UTTERANCE_SUCCESS = 'LOAD_TEST_UTTERANCE_SUCCESS';
export const LOAD_ALL_INTENTS_COUNT_SUCCESS = 'LOAD_ALL_INTENTS_COUNT_SUCCESS';
export const STORE_NOTIFICATION_COUNT_SUCCESS = 'STORE_NOTIFICATION_COUNT_SUCCESS';
export const LOAD_APP_ENV_SUCCESS = 'LOAD_APP_ENV_SUCCESS';
export const SEND_CHANNEL_SERVICE_SUCCESS = 'SEND_CHANNEL_SERVICE_SUCCESS';
export const SHOW_USER_MESSAGE_SUCCESSUSER = 'SHOW_USER_MESSAGE_SUCCESSUSER';
export const SEND_ERROR_MESSAGE = 'SEND_ERROR_MESSAGE';
export const SAVE_CHANNEL_SUCCESSCH= 'SAVE_CHANNEL_SUCCESSCH';
export const SAVE_REFERRER_SUCCESSRE= 'SAVE_REFERRER_SUCCESSRE';